/**
 * TanStack Query hooks for `regional-support-hours`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	regionalSupportHoursQueryKeys,
	type CreateRegionalSupportHoursBody,
	type ListRegionalSupportHoursResponse,
	type RegionalSupportHoursRow,
} from "./api";

export function useRegionalSupportHoursList(): UseQueryResult<ListRegionalSupportHoursResponse, Error> {
	return useQuery({
		queryKey: regionalSupportHoursQueryKeys.list(),
		queryFn: list,
	});
}

export function useRegionalSupportHoursCreate(): UseMutationResult<RegionalSupportHoursRow, Error, CreateRegionalSupportHoursBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: regionalSupportHoursQueryKeys.all });
		},
	});
}

export function useRegionalSupportHoursDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: regionalSupportHoursQueryKeys.all });
		},
	});
}
